import file from '../../../common/file';

class File {
  constructor() {}
  getSignedUrl(file: file | string): Promise<string> {
    return new Promise((resolve) => resolve(''));
  }
}

export default File;
